type ProjectListState = {
  open: any[];
  closed: any[];
  openProjectsCount: number;
  closedProjectsCount: number;
};

export const findProjectIndex = (projects: any[], id: any): number =>
  projects.findIndex((project: any) => String(project._id) === String(id));

export const applyProjectStatusUpdate = (
  state: ProjectListState,
  payload: any,
): ProjectListState => {
  const projectIndex = findProjectIndex(state.open, payload._id);

  if (projectIndex < 0) {
    return state;
  }

  const allOpenProjects = [...state.open];
  const updatedProject = {
    ...allOpenProjects[projectIndex],
    ...payload,
  };

  allOpenProjects[projectIndex] = updatedProject;

  if (payload.projectstatus?.key === 'finished') {
    const allClosedProjects = [...state.closed];
    allClosedProjects.push(updatedProject);
    allOpenProjects.splice(projectIndex, 1);

    return {
      ...state,
      open: allOpenProjects,
      closed: allClosedProjects,
      openProjectsCount: Math.max(0, state.openProjectsCount - 1),
      closedProjectsCount: state.closedProjectsCount + 1,
    };
  }

  return {
    ...state,
    open: allOpenProjects,
  };
};

export const asProjectArray = (projects: any): any[] =>
  Array.isArray(projects) ? projects : [];
